import { render, staticRenderFns } from "./recipesRawMaterial.vue?vue&type=template&id=816906a6&"
import script from "./recipesRawMaterial.vue?vue&type=script&lang=js&"
export * from "./recipesRawMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports